import { Endorsement, PhotographyAlbum, ProjectCarouselCard, SkillsByCategory, TimelineElementExperience } from "./types";

// https://heroicons.com/outline

export const ExperienceSectionData: TimelineElementExperience[] = [
  {
    id: 1,
    jobPosition: "Python Tutor",
    companyName: "Accel Learning",
    companyLogo: require("../src/assets/accel-learning-logo.png"),
    location: "New York, NY",
    date: "Nov 2020 – Aug 2021",
    description: [
      "Instructed students on the basics of programming in Python and helped spark their interest in the field of computer science",
      "Developed an easy-to-understand project-based Python curriculum designed for high school and middle school students",
      "Taught students Python modules like PyGame and Matplotlib to create various games and complex physics simulations",
    ],
    skillsUsed: ["Python", "Tutoring", "Curriculum Development"],
    links: [],
  },
  {
    id: 2,
    jobPosition: "Software Engineer",
    companyName: "Mentor Labs",
    companyLogo: require("../src/assets/mission-mentor-logo.png"),
    location: "Boston, MA",
    date: "Aug 2021 – Apr 2022",
    description: [
      "Developed a full-stack application using the PERN (PostgreSQL, Express.js, React.js, Node.js) stack to assist thousands of high school students in the college admissions process via a virtual guidance counselor and summer program recommendations",
      "Implemented a matching algorithm for scholarship/summer programs and leveraged React.js to create a seamless UX on the landing page, dashboard, scholarships, and summer programs pages, resulting in a 25% increase in user retention",
      "Contributed to a cross-functional development team while following the Agile Scrum methodology and establishing weekly team goals/timelines, leading to a global user base of over 10,000 students and incubation at the Harvard Innovation Labs",
    ],
    skillsUsed: ["React.js", "Typescript", "PostgreSQL", "Java Spring", "AWS"],
    links: [],
  },
  {
    id: 3,
    jobPosition: "Summer Extern",
    companyName: "Cisco Systems",
    companyLogo: require("../src/assets/cisco-logo.png"),
    location: "New York, NY",
    date: "Jul 2022",
    description: [
      "Participated in a highly selective program (~10% out of 900+ applicants) to gain industry experience in IoT and cybersecurity",
      "Formulated and presented innovative solutions for mass transit challenges using Cisco technologies such as Meraki MR56 Camera systems, LoRaWAN, and CyberVision, resulting in increased rail ridership and enhanced rider safety",
      "Achieved NYC Extern of the Day by excelling in workshops, shadowing company executives, and demonstrating leadership and technical skills in IoT, AI/ML, and Meraki Solutions, among various other networking technologies",
    ],
    skillsUsed: ["Internet of Things", "Cybersecurity", "Networking"],
    links: [],
  },
  {
    id: 4,
    jobPosition: "Academy of Math and Programming Fellow",
    companyName: "Jane Street",
    companyLogo: require("../src/assets/jane-street-logo.png"),
    location: "New York, NY",
    date: "Jul 2023 – Aug 2023",
    description: [
      "Designed and implemented algorithmic solutions to complex problems in game theory, graph theory, and linguistics using Python, enhancing skills in data analysis, decision-making under uncertainty, and quantitative trading strategies",
      "Achieved 7th place in Jane Street's Electronic Trading Challenge (ETC) by developing high-frequency trading algorithms in a competitive 6-hour trading session, resulting in one of the highest Profit-and-Loss (P&L) scores among 80+ participants",
      "Collaborated with International Math Olympians to complete intensive coursework in combinatorics and number theory",
    ],
    skillsUsed: ["Python", "Graph Theory", "Combinatorics", "Number Theory"],
    links: [],
  },
  {
    id: 5,
    jobPosition: "Associate Software Engineer Intern",
    companyName: "Vertice AI",
    companyLogo: require("../src/assets/vertice-ai-logo.png"),
    location: "Durham, NC",
    date: "Jun 2024 – Aug 2024",
    description: [
      "Developed an analytics solution using Python, PostgreSQL, Express.js, React.js, and AWS technologies to assist credit unions in tracking growth/engagement and identifying marketing opportunities for specific members",
      "Automated the generation of transaction models by implementing a component-based system with vectorized full-text search to analyze member behaviors, resulting in a 40% reduction in code volume and a 50% improvement in runtime efficiency",
      "Devised predictive models to efficiently analyze $5 billion+ in member transactions, track spending trends, and categorize members for partnered credit unions to know, grow, and measure their overall membership",
    ],
    skillsUsed: ["React.js", "Typescript", "PostgreSQL", "Express.js", "Python", "AWS", "Data Science"],
    links: [],
  },
  {
    id: 6,
    jobPosition: "Backend Software Engineer Intern | Trading Infrastructure",
    companyName: "Wealthfront",
    companyLogo: require("../src/assets/wealthfront-logo.png"),
    location: "Palo Alto, CA",
    date: "May 2025 – Aug 2025",
    description: [
      "Designed and implemented a low-latency trade order pricing system for low-liquidity, wide bid/ask spread instruments to improve allocation prices and reduce order cancellations using Java, Hibernate, and MariaDB",
      "Authored and presented in-depth technical design documents with historical incident analyses, UML diagrams, and code-level insights to senior leadership, enabling deployment of the optimized pricing system across trading infrastructure",
      "Automated the pruning of stale trade account data via batch processing jobs on Apache Airflow, removing over 600K rows daily and 40 million rows of data total to improve query performance and ensure high concurrency for account processes",
    ],
    skillsUsed: ["Java", "JUnit", "MariaDB", "Hibernate ORM", "Apache Airflow", "Guice", "Guava"],
    links: [],
  },
];

export const ProjectsSectionData: ProjectCarouselCard[] = [
  {
    id: 1,
    image: require("../src/assets/elytra.png"),
    title: "Elytra",
    description: "An open source, AI-powered database management tool that allows on-call engineers to streamline incident analysis.",
    fullDescription:
      "Elytra is an open source, AI-powered database management tool that allows on-call engineers to streamline incident analysis by using natural language to explore data, generate complex SQL queries, and visualize trends/anomalies.",
    skillsUsed: ["TypeScript", "Express.js", "Python", "FastAPI", "RAG", "Electron", "AWS", "PostgreSQL", "React.js", "Node.js"],
    projectLink: "https://elytradb.com",
    additionalLinks: [],
  },
  {
    id: 2,
    image: require("../src/assets/tutorconnect.png"),
    title: "Tutor Connect",
    description: "A web application that connects students with tutors for personalized learning experiences.",
    fullDescription:
      "Tutor Connect is an online platform that allows high school students to instantly connect with qualified and verified tutors. The site was quickly adopted by the Secaucus Public School District and serves over 500 students and 60 verified tutors daily. The platform comes fully equipped with an administator dashboard that allows school staff to manage student permissions, view analytics, and gain insight into the platform's usage.",
    skillsUsed: ["React.js", "TypeScript", "HTML", "CSS", "Node.js", "Firebase"],
    projectLink: "https://tutorconnect.sboe.org",
    additionalLinks: [],
  },
  {
    id: 3,
    image: require("../src/assets/signslate.png"),
    title: "Signslate",
    description: "A web application that allows users to speak and translate English to American Sign Language (ASL) and ASL to English in real-time.",
    fullDescription:
      "Signslate is a web application that allows users to speak and translate English to American Sign Language (ASL) and ASL to English in real-time via webcam or microphone input and displays the ASL translation using web-scraped videos. The site web-scrapes videos off the internet using a Flask python server and displays them on a ReactJS frontend for translating speech to ASL. To translate ASL to English, the site uses a custom trained machine learning model to recognize ASL gestures and translate them to English. The site received 1st place in the Diversity and Inclusion Category of the High Tech Hacks 2021 Hackathon, 1st place overall in the Simplihacks 2021 Hackathon, and won the Wolfram Alpha Award.",
    skillsUsed: ["React.js", "Python", "Flask", "TypeScript", "HTML", "CSS", "Node.js", "Firebase"],
    projectLink: "https://github.com/krushaybhavsar/signslate",
    additionalLinks: [],
  },
  {
    id: 4,
    image: require("../src/assets/tileshift.png"),
    title: "Tileshift",
    description: "A daily web-based word puzzle game.",
    fullDescription:
      "Tileshift is a daily web-based word puzzle game. The goal of the game is to align tiles to spell a word and turn them green. To win the game, players must use all the tiles within thirty moves. Players can also compete against friends and share their results. The site has gained over 125,000 hits on Reddit with an estimated 410 players across 3 different continents and an average engagement time of 7 minutes and 40 seconds per user.",
    skillsUsed: ["React.js", "TypeScript", "HTML", "CSS", "Node.js", "Firebase"],
    projectLink: "https://tileshiftgame.com",
    additionalLinks: [],
  },
  {
    id: 5,
    image: require("../src/assets/privalink.png"),
    title: "Privalink",
    description: "A platform to generate secure, private, and encrypted self-destructive links for sharing sensitive information.",
    fullDescription:
      "Privalink allows you to send any sensitive data or information to people you trust using self-destructing links. After someone has viewed the link, all sensitive data will be deleted from the Firebase firestore and the link will no longer be available for use. The site also gives users the option to instantly get notified via email after the link is opened and to set an expiration date for the link.",
    skillsUsed: ["React.js", "TypeScript", "HTML", "CSS", "Node.js", "Firebase"],
    projectLink: "https://privalink.app",
    additionalLinks: [],
  },
];

export const SkillsSectionData: SkillsByCategory[] = [
  {
    categoryTitle: "Programming & Markup Languages",
    skills: [
      { name: "TypeScript" },
      { name: "JavaScript" },
      { name: "Python" },
      { name: "Java" },
      { name: "C" },
      { name: "C#" },
      { name: "SQL" },
      { name: "HTML" },
      { name: "CSS" },
      { name: "XML" },
      { name: "MATLAB" },
    ],
  },
  {
    categoryTitle: "Frameworks & Libraries",
    skills: [
      { name: "React.js" },
      { name: "React Native" },
      { name: "Node.js" },
      { name: "Express.js" },
      { name: "Next.js" },
      { name: "Electron" },
      { name: "FastAPI" },
      { name: "GraphQL" },
      { name: "Prisma" },
      { name: "Hibernate" },
      { name: "Redux" },
      { name: "Spring Boot" },
      { name: "JUnit" },
      { name: "Flask" },
      { name: "Django" },
      { name: "NumPy" },
      { name: "TensorFlow" },
    ],
  },
  {
    categoryTitle: "Tools",
    skills: [
      { name: "PostgreSQL" },
      { name: "MariaDB" },
      { name: "Amazon Web Services (AWS)" },
      { name: "Docker" },
      { name: "Firebase" },
      { name: "Git" },
      { name: "Jira" },
      { name: "Android Studio" },
      { name: "Unity" },
      { name: "Arduino" },
    ],
  },
];

export const EndorsementsSectionData: Endorsement[] = [
  {
    headshot: require("./assets/patrick-moloney.jpeg"),
    name: "Patrick Moloney",
    title: "Head of Product at Vertice AI",
    content:
      "Krushay was a phenomenal addition to the team throughout the duration of his internship with Vertice AI. He constantly impressed us, beating deadlines, taking leadership, coming up with innovative solutions.",
    context: "Worked with Krushay at Vertice AI",
  },
  {
    headshot: require("./assets/robert-wachen.jpeg"),
    name: "Robert Wachen",
    title: "Co-Founder & COO at Etched, Thiel Fellow",
    content:
      "Krushay is an awesome team member and software engineer. He consistently puts out clean, efficient, well-functioning code and does it faster than most programmers I know.\n\nKrushay worked on a team of MIT and Harvard engineers. Krushay not only pulled his own weight but also taught them how to write more scaleable code and use new frameworks and libraries. He's sharp, thinks from first principles, and is a joy to work with.",
    context: "Managed Krushay directly at Mentor Labs (acquired)",
  },
  {
    headshot: require("./assets/luke-weidner.jpeg"),
    name: "Luke Weidner",
    title: "Head of Engineering at Vertice AI",
    content:
      "100% recommend Krushay - we expected a lot from him at Vertice and he delivered. He's great to work with and was able to pick up our system very quickly.",
    context: "Managed Krushay directly at Vertice AI",
  },
];

export const PhotographyScreenData: PhotographyAlbum[] = [
  {
    id: 1,
    title: "Costa Rica",
    dir: "costa-rica",
    length: 14,
    imageHashes: [
      "UA8q~4IA8x*I-:M}Mzoy8wyC%#MJ4pxt-:jY",
      "UEC%BCCTvos#%%XWnTav5S=zNIbbNfxuNfbc",
      "U?AVO@W?WAj]X=floLfkMxjYkCa|nMjZWWaz",
      "U]G]XOadV@oe?df6axofxtofj]ofWAoej]j]",
      "UNCaYcIdH;-QeBoHSwXS.TtSVqjD.9R,Mvt6",
      "U*FZNfxujYod?wt7ofoLofj[ogofRjWBaeof",
      "UEMshvozD,-.~lxGWB$~M}x?9d9J=@NHR*s+",
      "U7F7p@DAEv%^I^03mpM|01Dk,LrvHcDR*D.Q",
      "UHGI;tTH.O??J5fUjK%cICR$M|I.InD*IUIU",
      "UbF6wrO_pLxv%iNGRjt6RORNaKW?R*jct7Rk",
      "UN9*ogx|t:x_R4neoYV?9ERiRORibcWGWEax",
      "UJG7*h$%5SxC~Bs:R+oIOsS#WEslNeofkCjY",
      "URD[:}s:E2WV~BoMNHayEka}s.a#9~bHxZaz",
      "U9Bp]|t-9Fny~pb_t2RO%NjYE0M|ozxCIoRp",
    ],
  },
  {
    id: 2,
    title: "Abu Dhabi",
    dir: "abu-dhabi",
    length: 6,
    imageHashes: [
      "UhGuRPofIpof~qj[Rkj[S*j[s,a}9vj[t5az",
      "UaE.kOS5E2xZ~WWYIps:o#a#j[WCE5oLt6Rk",
      "UIDT}2:zv{ktgS$_oHRi9jtTt7n#-NR:kBt7",
      "U9HCQROwtl?G00D*IAbw4V-h.8IV~o=?MxNf",
      "U5Hw#*-T01-o.mj[MyWB-=s.NKazIYaybdWX",
      "UHAme=^+t5s:?w-ps.of9vRkaxfQ9FIVR+ay",
    ],
  },
  {
    id: 3,
    title: "New York City",
    dir: "nyc",
    length: 8,
    imageHashes: [
      "UoE|GGX9t7ogpfbcj[bIIAoJWBaes7WBkCay",
      "U;E:rco#RjjZ?wkDayj[o#WCs:ogRjRij[j]",
      "U+FZKdt7oJoe.TkCfkj]OaW=a#a}NLjsayf6",
      "USE|JJxttQxsG1xsofWVDjNHWXf6jEt6kCof",
      "U]9Iu;yGtSkCkDkCf6aeaeayazayj]j]j[fQ",
      "U15N_p5t00}Q0|$L}s1O}tEM5Q^3JVxa$y9v",
      "UjGuwS%1jEof~qxVjsofOZofoJjZE3WrofoL",
      "U6BW}7.600D#NQ%2aIDi9.4tMc$_Dgox?wj?",
    ],
  },
  {
    id: 4,
    title: "Atlanta",
    dir: "atlanta",
    length: 8,
    imageHashes: [
      "UrBO2bkDX9WAlCkEofadNOkXn}oJngbcV?f5",
      "UaEB?dXSNGxF~EozR*oLXoxaoJS2Ehsos.WW",
      "U56a-y%jMvRNN*R:W9of00itxwp0r,aKo$aw",
      "U15q*BD*00~A00%LtR4;S^wH-o-:9GK6%1Mx",
      "U77T,:j[0LjbJ7ayxZj[0Kay~Bfk^jbH9vjZ",
      "Ue1rBaacaKkElCacaekDkXacfRkAjEadf+kC",
      "UF0ob6lCZzaikbj_aee.kjk8aKf6e]flf+fl",
      "UF0MToeke5e*dCg6gPfTeiemfnf,glfhf-f,",
    ],
  },
  {
    id: 5,
    title: "Açores",
    dir: "acores",
    length: 21,
    imageHashes: [
      "U@A2ZGjZaeogTOWCf6WYVvj@ofj?nLjsbIa{",
      "UoCj*9ktRkt6.AkXRjt7x]V@V@t7t7RjjYt6",
      "UfB|dEE3aIay?wIqaej?tUWDjrkCI[s:ogoe",
      "USC%5Jt7E2f5~qjZIpj]kWj[jua#ESkCslWC",
      "URBz5@9aNG%1?wIVR*t6ETxBs.R,E2xZoeR*",
      "U~B}h5n}oKoft:ofj@j]o~kDjufQRnbIbHfP",
      "UVEyrcRPRixa_4t8V@s.bxxus+oJkYt7xYt6",
      "U~Ctw@t6fjbIyGoffkbINMkCj]a#M_WWjuj[",
      "UmB4LBf4ROof.ARjROkC%iV@RifP%OWBaeax",
      "UWDSgxD+WVoI~WIVWqn$kXjEkCjYENxZj[ae",
      "U~F6^VSislof.AS6j[ofohR.WYj?RPWDjsj?",
      "UmEV{U$yM{o#?wxXR-WXtmt6ofWBR:S4oJs:",
      "U?DmtB$|oIkC?wxtoKoLx^t7ocj?WGj@odj[",
      "UJDuxd0is*jG~VIrWAj[0i=_RQkCE3%0Rkoy",
      "UIBDA{rqV@%0?wnhWAaz0$bca|IqE1X9oeof",
      "Uw8PNDbIWAkCpMj[j?fkMyaekCf6Vqf6a#fQ",
      "UyFsYwtRWBt6?dogWBof%NWUazoftQV@j[j]",
      "U?GSy8NMfkWY?wNIj[a#aeV@odjsM{oJoeay",
      "UhC7m2%ht2obx|xws+j=p1o#aKj[X9W-acbI",
      "UrG]2S%%NHROa#R+WXs:t7WCa#oft7WVofj[",
      "UMFiABxuE3kC.mkCxvof_4of%3s:.8of%3of",
    ],
  },
];
